import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import publicUsersListSaga from './sagas/publicUsersListSaga';

export default [
  // Lists
  ...createCombineMapItem('publicUsersList', createListReduceObject, [
    publicUsersListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/lists/reducersMap.js